var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowBackgroundVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#E99940"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1961 9.23047C20.0315 9.23047 20.8327 9.56234 21.4235 10.1531C22.0142 10.7438 22.3461 11.545 22.3461 12.3805V12.5481L26.0912 10.3015C26.2015 10.2353 26.3274 10.1995 26.456 10.1979C26.5847 10.1962 26.7114 10.2287 26.8234 10.2921C26.9353 10.3555 27.0285 10.4474 27.0933 10.5586C27.1581 10.6697 27.1922 10.796 27.1922 10.9247V22.0728C27.1922 22.2014 27.1581 22.3278 27.0933 22.4389C27.0285 22.55 26.9353 22.642 26.8234 22.7053C26.7114 22.7687 26.5847 22.8012 26.456 22.7996C26.3274 22.798 26.2015 22.7622 26.0912 22.696L22.3461 20.4493V20.6189C22.3461 21.4544 22.0142 22.2556 21.4235 22.8463C20.8327 23.4371 20.0315 23.7689 19.1961 23.7689H10.9576C10.1222 23.7689 9.32097 23.4371 8.73023 22.8463C8.13949 22.2556 7.80762 21.4544 7.80762 20.6189V12.3805C7.80762 11.545 8.13949 10.7438 8.73023 10.1531C9.32097 9.56234 10.1222 9.23047 10.9576 9.23047H19.1961ZM19.1961 10.6843H10.9576C10.5078 10.6843 10.0763 10.863 9.75826 11.1811C9.44016 11.4992 9.26146 11.9306 9.26146 12.3805V20.6189C9.26146 21.5552 10.0213 22.3151 10.9576 22.3151H19.1961C19.6459 22.3151 20.0774 22.1364 20.3954 21.8183C20.7135 21.5002 20.8922 21.0688 20.8922 20.6189V12.3805C20.8922 11.9306 20.7135 11.4992 20.3954 11.1811C20.0774 10.863 19.6459 10.6843 19.1961 10.6843ZM25.7384 12.2089L22.3461 14.2453V18.7532L25.7384 20.7885V12.2089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBackgroundVideo);
export default __webpack_public_path__ + "static/media/YellowBackgroundVideo.1808f41c600e04009460ee0324672627.svg";
export { ForwardRef as ReactComponent };